// Contrato ÚNICO de estados de cobertura (Bloque 1). Colores y etiquetas de marca.
export const ESTADO = { CUBIERTO: "cubierto", CON_RESERVAS: "con_reservas", SIN_EVIDENCIA: "sin_evidencia" };

export const COBERTURA_STYLE = {
  cubierto: { color: "#22C55E", bg: "#F0FDF4", border: "#22C55E", label: "Cubierto" },
  con_reservas: { color: "#B45309", bg: "#FFFBEB", border: "#F59E0B", label: "Cubierto con reservas" },
  sin_evidencia: { color: "#EF4444", bg: "#FEF2F2", border: "#EF4444", label: "Sin evidencia" },
};

// Etiqueta específica para KO pendiente de confirmación humana.
export function estadoLabel(r) {
  if (r.estado_cobertura === ESTADO.CON_RESERVAS && r.pendiente_confirmacion) return "Pendiente de tu confirmación";
  return COBERTURA_STYLE[r.estado_cobertura]?.label || "—";
}

// Agrega los totales a partir de los capítulos de /norma/cobertura.
export async function fetchKoPendientes(api) {
  try {
    const { data } = await api.get("/norma/cobertura");
    let n = 0;
    (data.capitulos || []).forEach((c) => (c.requisitos || []).forEach((r) => {
      if (r.es_critico && r.pendiente_confirmacion) n += 1;
    }));
    return n;
  } catch { return 0; }
}

// Agrega los totales a partir de los capítulos de /norma/cobertura.
export function resumenCobertura(cob) {
  if (!cob) return { total: 0, cubiertos: 0, reservas: 0, sinevidencia: 0, porcentaje: 0, koSinConfirmar: 0 };
  let koSinConfirmar = 0;
  (cob.capitulos || []).forEach((cap) => (cap.requisitos || []).forEach((r) => {
    if (r.es_critico && r.pendiente_confirmacion) koSinConfirmar += 1;
  }));
  return {
    total: cob.total || 0,
    cubiertos: cob.cubiertos || 0,
    reservas: cob.con_reservas || 0,
    sinevidencia: cob.sin_evidencia || 0,
    porcentaje: cob.cobertura_pct || 0,
    koSinConfirmar,
  };
}
